import Icon from '../components/Icon.vue'

Icon.register({
  'truck-loading': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M50.2 375.6l-49.6-185.5c-2.3-8.5 2.8-17.3 11.3-19.6l77.3-20.7 24.8 92.7 61.8-16.5-24.8-92.7 77.2-20.8c8.5-2.3 17.3 2.8 19.6 11.3l49.7 185.5c2.3 8.5-2.8 17.3-11.3 19.6l-216.4 58c-8.5 2.3-17.3-2.8-19.6-11.3zM384 0h256v400c0 61.9-50.1 112-112 112-60.4 0-109.2-47.9-111.6-107.7l-393.7 107.4c-4.2 1.2-8.6-1.3-9.8-5.6l-12.6-46.3c-1.2-4.2 1.3-8.6 5.6-9.8l346.1-94.4v-323.6c0-17.7 14.3-32 32-32zM528 448c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/truck-loading.js
// module id = 2035
// module chunks = 0